import { useState, useContext } from "react";
import { ArrowRightIcon } from "../../kits/Icons/Icons.tsx";
import { CustomInput } from "../../kits/inputs/Input.tsx";
import CustomButton from "../../kits/custom-button/CustomButton.tsx";
import { NavLink } from "react-router-dom";
import useAxios from "../../../services/useAxios.tsx";
import { useNavigate } from "react-router-dom";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext";
import { nameChecker } from "../../../utilities/regexCheckers";

export default function UserInformation() {
  const auth = useContext(AuthenticationContext);
  const navigation = useNavigate();
  const [userInfoFname, setUserInfoFname] = useState(auth.userInfo.firstname);
  const [userInfoLname, setUserInfoLname] = useState(auth.userInfo.lastname);
  const [userInfoMobile, setUserInfoMobile] = useState(auth.userInfo.mobile);

  const { loading, execute: EditUserData, cancel } = useAxios("api/updateuser");
  const editUser = () => {
    EditUserData({
      userId: auth.userInfo.id,
      updateValue: `fname,${userInfoFname}@@lname,${userInfoLname}`,
    }).then((data) => {
      if (data.status == 1) {
        navigation("/user-profile");
        auth.changeUserInfo({
          firstname: userInfoFname,
          lastname: userInfoLname,
        });
      }
    });
  };

  return (
    <div className="user-info-style">
      <div className="d-flex align-items-center pd-24 ">
        <NavLink to="/user-profile">
          <ArrowRightIcon />
        </NavLink>

        <h6 className="pd-r-8 title-h3-b">اطلاعات کاربری</h6>
      </div>
      <div className="d-flex flex-column ">
        <div className="pd-x-16 pd-b-20">
          <CustomInput
            title="نام"
            placeholder="نام خود را وارد کنید"
            value={userInfoFname}
            containerClassName="mr-t-32"
            onChange={(e) => {
              if (nameChecker(e.target.value)) {
                setUserInfoFname(e.target.value);
              }
            }}
            inputType="input"
          />
          <CustomInput
            title="نام خانوادگی"
            placeholder="نام خانوادگی خود را وارد کنید"
            value={userInfoLname}
            containerClassName="mr-t-32"
            onChange={(e) => {
              if (nameChecker(e.target.value)) {
                setUserInfoLname(e.target.value);
              }
            }}
            inputType="input"
          />
          <CustomInput
            title="شماره موبایل"
            placeholder=""
            value={userInfoMobile}
            containerClassName="mr-t-32 pd-b-40"
            onChange={(e) => setUserInfoMobile(e.target.value)}
            inputType="input"
            disabled={true}
            className="txt-t3-m"
          />
        </div>
      </div>

      <div
        className="pd-x-20 w-100 text-center edit-userprofile mr-x-auto mr-b-20"
        style={{
          position: "fixed",
          bottom: "0px",
          right: "0px",
          left: "0px",
        }}
      >
        <CustomButton
          className="custom-button w-100 title-h4-m "
          buttonType="primary"
          size="large"
          onClick={() => {
            editUser();
          }}
        >
          ویرایش
        </CustomButton>
      </div>
    </div>
  );
}
